import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Birch from '../../img/Agenda/Birch.png'
import Buffer from '../../img/Agenda/Buffer.png'
import Sinanyan from '../../img/Agenda/Sinanyan.png'
import PicsartArmenia from '../../img/Agenda/PicsartArmenia.png'
import Candia from '../../img/Agenda/Candia.png'
import HokenTech from '../../img/Agenda/Hoken Tech.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
              {
                  id: 1,
                  time: '10:00',
                  photo: Birch,
                  name: 'Joe Birch',
                  position: 'Android Engineer',
                  ln: 'https://www.linkedin.com/in/j-birch/',
                  tw: 'https://twitter.com/hitherejoe',
                  logo: Buffer,
                  title: 'Building Compose Apps for everyone',
                  abstract: `Did you know that 15% of the world's population experience some form of disability? Yet even with this high number, accessibility is often an afterthought for many projects — meaning that many of the things we build end up creating barriers for users who utilize accessibility features. With tools like Jetpack Compose, there is reduced friction in supporting these things in our apps — we just need to have the knowledge of how to implement them.

                  In this talk we’ll explore common accessibility pitfalls, along with how they can be tackled within Jetpack Compose. You’ll leave with the confidence and knowledge to make your apps more accessible for everyone!`,
              },
              {
                  id: 2,
                  time: '10:45',
                  photo: Sinanyan,
                  name: 'Andranik Sinanyan',
                  position: 'Android Developer',
                  ln: 'https://www.linkedin.com/in/andosinanyan/',
                  logo: PicsartArmenia,
                  title: 'Best practice of implementing Android In App Purchases',
                  abstract: `1.  In App Purchases
                  In-app purchasing refers to buying goods and services from inside an application on a mobile device, such as a smartphone or tablet.
                  2. What kind of IAP are (consumable, non-consumable, auto-renewable, and non-renewing subscriptions.
                  2. How to Implement Google In-App Billing (with some code snippets ) Here, we can talk about the steps of implementation, the listeners of google billing, after getting a google play subscription response how to validate with your back-end(which makes your application billing system secure)
                  3. Google billing frequency.
                  4. After finishing the subscription period, what will Google play(grace, on hold).`,
              },
              {
                  id: 3,
                  time: '11:30',
                  photo: Candia,
                  name: 'Alfredo de Candia',
                  position: 'CTO - Tech Lead',
                  ln: 'https://www.linkedin.com/in/alfredo-de-candia-996662178/',
                  tw: 'https://twitter.com/AlfredodeCandi1',
                  logo: HokenTech,
                  title: 'How to develop an Android app for blockchain',
                  abstract: `Why is it important to develop Android apps for Blockchain?
                  In a centralized world and employed by the hi-tech giants, many independent developers do not have to comply with the rules of these marketplaces both in terms of what to publish and how to publish it and with relative prices.
                  By now the blockchain has spread in recent years but still involves few people compared to the global potential of smartphone users, and this diffusion of the blockchain can only be achieved by bringing it into the devices that everyone uses, that is smartphones, and to do so we need applications that integrate the blockchain.
                  Thanks to these applications it is possible to obtain all the advantages of both worlds, the centralized and the decentralized one as thanks to the integration of different APIs it is possible to integrate wallets and more, transforming the application into a decentralized application, which can also be used on any device.
                  
                  You will learn more about:
                  
                  Steps to develop an Android decentralized application
                  Android development framework overview
                  How should you program an Android app that uses the blockchain?
                  What are Blockchain-based Smart Contracts?
                  Advantages of building decentralized applications (dApps)
                  Which blockchain to use?
                  And more!`,
              },
          ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">June 21 10:00 - 21:00</p>
                    <p className="agenda_day">Career Track</p>
                    <VideoPresent speakers={this.state.list}/>
                    <a className='full_agenda_btn' href='https://geekle.us/schedule/android?track=1620461255275x153572830459985920' target='_blank' rel="noreferrer">SHOW FULL AGENDA</a>
                </div>
            </div>
        );
    }
};